module.exports = __webpack_public_path__ + "6dbfbc5f1848ec20659a1a7634c964d4.png";